module.exports = __webpack_public_path__ + "img/Coupe_Back.94ba1aa8.svg";